(function() {
	// globals
	PM.People = {};
	PM.People.roles = [];

	// app functions
		PM.People.renderPeoplePage = function() {
		PM.Shell.setSidebarActive('people');
		PM.Shell.setBreadcrumb([{ label: i18next.t('People') }]);
		$.when(
			$.get('/api/people'),
			ejs.preloadTemplate('/app/people/templates/people.ejs'),
			ejs.preloadTemplate('/app/people/templates/person-row.ejs')
		).done(function() {
			var people = arguments[0][0] || arguments[0];
			$('.js-page-container').html(ejs.rr('/app/people/templates/people.ejs', { people: people }));
		});
	};

	// Show the add/edit modal
	PM.People.showModal = function(person) {
		var isEdit = !!person;
		var modalTitle = isEdit ? i18next.t('Edit Person') : i18next.t('Add Person');

		// For edit, extract current role IDs from person.roles array
		var personRoles = [];
		if (isEdit && person.roles && person.roles.length > 0) {
			personRoles = person.roles.map(function(r) { return r.id; });
		}

		$.when(
			$.get('/api/roles'),
			ejs.preloadTemplate('/app/people/templates/person-modal.ejs')
		).done(function(roles) {
			var modalHtml = ejs.rr('/app/people/templates/person-modal.ejs', {
				modalTitle: modalTitle,
				person: person || {},
				roles: roles[0],
				personRoles: personRoles
			});

			var $modal = $(modalHtml);
			$('body').append($modal);
			var bsModal = new bootstrap.Modal($modal[0]);
			bsModal.show();

			// Clean up on hidden
			$modal.on('hidden.bs.modal', function() {
				$modal.remove();
			});

			// Initialize choices.js multi-select for roles
			$modal.on('shown.bs.modal', function() {
				var $select = $modal.find('.js-person-roles');
				if ($select.length > 0) {
					setTimeout(function() {
						var choices = new Choices($select[0], {
							removeItemButton: true,
							placeholderValue: i18next.t('Select roles...'),
							searchEnabled: false,
							itemSelectText: ''
						});
						$select.data('choices', choices);
					}, 0);
				}
				$modal.find('.js-person-name').focus();
			});
		});
	};

	// events

	// "Add Person" button
	$(document).on('click', '.js-people-add', function(e) {
		e.preventDefault();
		PM.People.showModal(null);
	});

	// Edit button on a row
	$(document).on('click', '.js-people-edit', function(e) {
		e.preventDefault();
		var id = $(this).data('person-id');
		$.get('/api/people/' + id, function(person) {
			PM.People.showModal(person);
		});
	});

	// Save button in modal
	$(document).on('click', '.js-people-save', function() {
		var $modal = $(this).closest('.js-people-modal');
		var id = $modal.find('.js-person-id').val();
		var name = $modal.find('.js-person-name').val().trim();
		var email = $modal.find('.js-person-email').val().trim();
		var workhours = $modal.find('.js-person-workhours').val();

		if (!name) {
			new Notify({ status: 'error', text: i18next.t('Name is required.'), timeout: 3000 });
			return;
		}

		// Collect selected role IDs from choices.js
		var roles_ids = [];
		var $rolesSelect = $modal.find('.js-person-roles');
		if ($rolesSelect.length > 0) {
			var choices = $rolesSelect.data('choices');
			if (choices) {
				roles_ids = choices.getValue({ valueOnly: true }).map(function(v) { return parseInt(v, 10); });
			}
		}

		var data = {
			name: name,
			email: email || null,
			workhours: workhours ? parseFloat(workhours) : null,
			show_in_plan: $modal.find('.js-person-show-in-plan').is(':checked')
		};

		var request;
		if (id) {
			request = $.ajax({
				url: '/api/people/' + id,
				method: 'PUT',
				contentType: 'application/json',
				data: JSON.stringify(data)
			});
		} else {
			request = $.ajax({
				url: '/api/people',
				method: 'POST',
				contentType: 'application/json',
				data: JSON.stringify(data)
			});
		}

		request.done(function(personOrResult) {
			if (id) {
				$.ajax({
					url: '/api/people/' + id + '/role',
					method: 'PUT',
					contentType: 'application/json',
					data: JSON.stringify({ roles_ids: roles_ids })
				}).always(function() {
					bootstrap.Modal.getInstance($modal[0]).hide();
					PM.People.renderPeoplePage();
					new Notify({ status: 'success', text: i18next.t('Person saved.'), timeout: 3000 });
				});
			} else {
				var newId = personOrResult.id;
				if (newId && roles_ids.length > 0) {
					$.ajax({
						url: '/api/people/' + newId + '/role',
						method: 'PUT',
						contentType: 'application/json',
						data: JSON.stringify({ roles_ids: roles_ids })
					}).always(function() {
						bootstrap.Modal.getInstance($modal[0]).hide();
						PM.People.renderPeoplePage();
						new Notify({ status: 'success', text: i18next.t('Person saved.'), timeout: 3000 });
					});
				} else {
					bootstrap.Modal.getInstance($modal[0]).hide();
					PM.People.renderPeoplePage();
					new Notify({ status: 'success', text: i18next.t('Person saved.'), timeout: 3000 });
				}
			}
		});
	});

	// Delete button on a row
	$(document).on('click', '.js-people-delete', function(e) {
		e.preventDefault();
		var id = $(this).data('person-id');
		var name = $(this).data('person-name');

		if (!confirm(i18next.t('Delete') + ' "' + name + '"? ' + i18next.t('This will also remove their plan entries.'))) {
			return;
		}

		$.ajax({
			url: '/api/people/' + id,
			method: 'DELETE'
		}).done(function() {
			PM.People.renderPeoplePage();
			new Notify({ status: 'success', text: i18next.t('Person deleted.'), timeout: 3000 });
		});
	});

	// app startup
	page('/people', PM.Shell.routeWithPermission('view_people', PM.People.renderPeoplePage));
})();
